import { EmptyState } from "../components/EmptyState.tsx";
import { useT } from "../lib/i18n.tsx";

export function NotFound() {
  const t = useT();
  return (
    <div className="page">
      <EmptyState icon="?" text={t("error.not_found")} cta={{ label: t("nav.home"), to: "/" }} />
    </div>
  );
}
